import {Component, EventEmitter, inject, Input, Output, ViewChild} from '@angular/core';
import {FormPopupComponent} from "../../../../components";
import {ShiftFormComponent} from "../shift-form/shift-form.component";
import {CreateShiftCommand, ShiftsClient} from "@services";
import notify from "devextreme/ui/notify";

@Component({
    selector: 'add-shift-form',
    imports: [
        FormPopupComponent,
        ShiftFormComponent
    ],
    templateUrl: './add-shift-form.component.html'
})
export class AddShiftFormComponent {
    @ViewChild(ShiftFormComponent, {static: false}) addNewForm: ShiftFormComponent;

    private shiftsClient = inject(ShiftsClient);

    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onSave = new EventEmitter();

    onPopupSaveClick = () => {
        let formData = this.addNewForm.getData();

        let createCommand = new CreateShiftCommand({
            shiftType: formData.shiftType,
            shiftStart: formData.shiftStart,
            shiftEnd: formData.shiftEnd,
            code: formData.code,
            days: formData.days,
            supervisorId: formData.supervisorId,
            locked: formData.locked,
            showInHuddle: formData.showInHuddle,
            hasMealTicked: formData.hasMealTicked,
            premiumRate: formData.premiumRate,
            mealTickedRoles: formData.mealTickedRoles
        })
        this.shiftsClient.createShift(createCommand).subscribe({
            next: async () => {
                this.visible = false;
                this.visibleChange.emit(this.visible);
                this.onSave.emit();
            },
            error: (errors: Array<any>) => {
                errors.forEach((errMsg => {
                    notify({
                        message: errMsg.message,
                        type: "error",
                        displayTime: 5000,
                    }, {
                        position: "bottom right",
                        direction: "up-push"
                    });
                }));
            }
        });
    };

    onVisibleChange(visible: boolean) {
        this.visibleChange.emit(visible);
    }
}
